<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-switch
        v-model="orderDescription.isValidIndustryClassification"
        label="業種分類"
        class="v-input--reverse"
      />
    </v-flex>
    <v-flex
      v-if="orderDescription.isValidIndustryClassification"
      xs10
      offset-xs1
    >
      <AppIndustrySelector
        :chosenItemsList="chosenItemList"
        @onChangeSelectedItemsList="updateIndustryClassificationTargets($event)"
      />
    </v-flex>
    <v-flex
      v-if="orderDescription.isValidIndustryClassification"
      xs10
      offset-xs1
      pa-4
    >
      <div>
        小分類での指定をご希望の場合備考欄へ別途ご記入下さい。<br />
        業種区分は
        <a
          href="https://www.soumu.go.jp/toukei_toukatsu/index/seido/sangyo/02toukatsu01_03000023.html"
          target="_blank"
          rel="noopener"
        >
          こちら
        </a>
        の区分を参照
      </div>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  name: 'CampaignModalPageOfficeIndustry',
  props: {
    menuSetting: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    orderDescription() {
      return this.menuSetting.orderDescription
    },
    chosenItemList() {
      return this.orderDescription.industryClassificationTargets
        .map(item =>
          item.industryClassificationCodeAndNames.map(codeAndName => {
            return {
              id: codeAndName.code,
              name: codeAndName.name,
              parentId: item.sectorCode,
              parentName: item.name,
              selected: false,
            }
          }),
        )
        .flat()
    },
  },
  methods: {
    updateIndustryClassificationTargets(value) {
      this.menuSetting.makeIndustryClassificationTargets(value)
    },
    validate() {
      if (!this.orderDescription.isValidIndustryClassification) {
        return true
      }
      return this.orderDescription.industryClassificationTargets.length !== 0
    },
  },
}
</script>

<style scoped lang="scss">
.v-input--reverse {
  ::v-deep .v-input__slot {
    flex-direction: row-reverse;
    .v-input--selection-controls__input {
      margin-left: 8px;
    }
  }
}
</style>
